import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { G_BUTTON__field_use_as_grid2d_column } from '../_base/_buttons/G_BUTTON__field_use_as_grid2d_column';
import { G_BUTTON__field_use_as_grid2d_row } from '../_base/_buttons/G_BUTTON__field_use_as_grid2d_row';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';

interface PROPS {
  field: FIELD__base;
}
export function G_UI_GRID2D_MODE__row_or_column({ field }: PROPS) {
  let { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  return (
    <div {...{ onMouseOver, onMouseLeave }}>
      <G_UI_FIELD__header {...{ field }} hide_buttons_grid2d_dimension>
        <>
          <G_BUTTON__field_use_as_grid2d_column {...{ field }} />
          <G_BUTTON__field_use_as_grid2d_row {...{ field }} />
        </>
      </G_UI_FIELD__header>
    </div>
  );
}
